/**
 * @author       jose.lucena@zumper.com (José Lucena)
 * @copyright    Copyright (c) 2025, Zumper
 * @description  metro rent report modal reducers
 */

import type { MetroRentReport } from '@zcode/bizos'
import { payloadReducer } from '@zcode/reducers'
import { handleActions } from 'redux-actions'
import { RECEIVE_DATA } from '../constants/metroRentReportModal'
import type { ActionTypes } from '../types'

export const metroRentReportReducer = handleActions<MetroRentReport | null, ActionTypes>(
  {
    [RECEIVE_DATA]: payloadReducer,
  },
  null
)
